import { supabase } from '@/shared/lib/supabase'

export interface StoredSignature {
  id: string
  user_id: string
  name: string
  signature_type: 'draw' | 'upload'
  image_data: string
  is_default: boolean
  created_at: string
}

const TABLE = 'sgw_stored_signatures'

export async function getStoredSignatures(): Promise<StoredSignature[]> {
  if (!supabase) throw new Error('Supabase no configurado')
  const { data, error } = await supabase
    .from(TABLE)
    .select('*')
    .order('is_default', { ascending: false })
    .order('created_at', { ascending: false })

  if (error) throw error
  return data || []
}

export async function saveSignature(params: {
  userId: string
  name: string
  signatureType: 'draw' | 'upload'
  imageData: string
  isDefault?: boolean
}): Promise<StoredSignature> {
  if (!supabase) throw new Error('Supabase no configurado')

  // If setting as default, unset others first
  if (params.isDefault) {
    await supabase
      .from(TABLE)
      .update({ is_default: false })
      .eq('user_id', params.userId)
  }

  const { data, error } = await supabase
    .from(TABLE)
    .insert({
      user_id: params.userId,
      name: params.name,
      signature_type: params.signatureType,
      image_data: params.imageData,
      is_default: params.isDefault ?? false,
    })
    .select()
    .single()

  if (error) throw error
  return data
}

export async function deleteSignature(id: string): Promise<void> {
  if (!supabase) throw new Error('Supabase no configurado')
  const { error } = await supabase.from(TABLE).delete().eq('id', id)
  if (error) throw error
}

export async function setDefaultSignature(id: string, userId: string): Promise<void> {
  if (!supabase) throw new Error('Supabase no configurado')
  // Unset all defaults
  await supabase.from(TABLE).update({ is_default: false }).eq('user_id', userId)
  // Set new default
  const { error } = await supabase.from(TABLE).update({ is_default: true }).eq('id', id)
  if (error) throw error
}
